"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Phenolicengravingtechnicaloverview() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: essayRef,
    isVisible: essayVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const paragraphs = ["Evermark Industrial Solutions was built on a singular, technical premise: that industrial identification should be as durable as the assets it marks. We do not view nameplates as office supplies. We view them as critical infrastructure components that must survive harsh environments, chemical exposure, and decades of service.", "Our focus is precision engineering. Every laser system, every CNC router, and every calibration protocol in our facility is maintained to ensure that your specifications are met with absolute fidelity. Compliance is not a goal — it is the baseline requirement for every tag we produce.", "We reject the ambiguity of generic labeling. Industrial environments demand clarity, high contrast, and material integrity. Whether it is a MIL-SPEC phenolic plate or a stainless steel valve tag, the output must be legible, permanent, and compliant with your specific project standards.", "Industrial marking is a discipline of documentation and execution. It is about understanding material properties, depth requirements, and mounting constraints. Our team operates as an extension of your engineering department, ensuring that every part list is processed, verified, and shipped to meet your project timeline.", "This is the standard that governs every order, every material selection, and every quality inspection. It is not a service. It is a commitment to industrial reliability."];
  return <section data-section-id="2461" id="phenolicengravingtechnicaloverview" className="bg-[#0F1B2D] text-[#E8E4DC] relative overflow-hidden py-32 md:py-[200px] px-6 md:px-12 lg:px-16">
      <div aria-hidden="true" className="hidden lg:block absolute right-0 top-1/2 -translate-y-1/2 pointer-events-none select-none" style={{
      transform: "translateY(-50%) rotate(90deg)",
      transformOrigin: "right center"
    }}>
        <span className="font-default font-black uppercase whitespace-nowrap" style={{
        fontSize: "clamp(8rem, 14vw, 16rem)",
        color: "var(--muted)",
        opacity: 0.1,
        letterSpacing: "0.05em",
        lineHeight: 1
      }}>
          EVERMARK
        </span>
      </div>

      <div className="relative mx-auto max-w-[1400px] grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-0">
        <div ref={headlineRef} className={`lg:col-span-4 lg:sticky lg:top-24 lg:self-start transition-all duration-1000 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="mb-6 md:mb-8">
            <p className="font-default font-bold uppercase text-primary mb-4" style={{
            fontSize: "0.75rem",
            letterSpacing: "0.2em"
          }}>
              Technical Standards
            </p>
            <div className="h-[2px] w-8 bg-primary" />
          </div>

          <h2 className="font-sans font-bold uppercase text-white" style={{
          fontSize: "clamp(3rem, 7vw, 7.5rem)",
          lineHeight: 0.92,
          letterSpacing: "-0.04em"
        }}>
            <span className="block text-primary !text-[88px]">
              Permanent<span style={{
              fontSize: "1.2em",
              lineHeight: 0
            }}>.</span>
            </span>
            <span className="block !text-[88px]">Compliant.</span>
            <span className="block !text-[88px]">Specified</span>
            <span className="block !text-[88px]">By Name.</span>
          </h2>
        </div>

        <div className="hidden lg:block lg:col-span-1" aria-hidden="true" />

        <div ref={essayRef} className={`lg:col-span-5 transition-all duration-1000 ease-out delay-200 ${essayVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="font-default text-[#E8E4DC]" style={{
          fontSize: "1.1875rem"
        }}>
            {paragraphs.map((paragraph, i) => <div key={i} data-index={i}>
                <p className={`leading-[1.65] ${i === 0 ? "" : "mt-0"}`}>
                  {i === 0 ? <>
                      <span className="block text-primary font-bold text-2xl mb-6 leading-tight">
                        Evermark Industrial Solutions was built on a singular, technical premise: that industrial identification should be as durable as the assets it marks.
                      </span>
                      <span className="font-default font-black float-left mr-3 mt-1 text-primary" style={{
                  fontSize: "5rem",
                  lineHeight: 0.85,
                  letterSpacing: "-0.04em"
                }}>
                        W
                      </span>
                      {paragraph.split(". ")[1]}. {paragraph.split(". ").slice(2).join(". ")}
                    </> : paragraph}
                </p>
                {i < paragraphs.length - 1 && <div className="h-px bg-border/30 my-8 w-full" />}
              </div>)}
          </div>

          <div className="my-12 md:my-16 pl-6 border-l-2 border-primary">
            <p className="font-default italic text-white" style={{
            fontSize: "1.75rem",
            lineHeight: 1.4,
            letterSpacing: "-0.01em"
          }}>
              "Industrial identification should be as durable as the assets it marks."
            </p>
          </div>

          <p className="font-default text-[#E8E4DC] leading-[1.65]" style={{
          fontSize: "1.1875rem"
        }}>
            We do not guess. We work from your prints, your specs, and your part lists. Every project is documented for traceability, ensuring that what you receive is exactly what you specified.
          </p>

          <div className="mt-16 md:mt-20 pt-8 border-t border-border">
            <div className="inline-block">
              <p className="font-default font-bold uppercase text-[#E8E4DC] inline-block border-b border-primary pb-1" style={{
              fontSize: "0.6875rem",
              letterSpacing: "0.18em"
            }}>
                Evermark Industrial Solutions &mdash; Veteran Owned
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}